<header class="fixed left-0 top-0 z-50 w-full bg-white px-10 py-6 shadow-md">
    <img class="w-12" src="images/logo/logo.svg" alt="Logo image" />
</header>
